import getReviewRatingSchema from './get-review-rating-schema';
/**
 * Get the minimum schema we need to achieve star ratings on SERPs.
 *
 * Note: When we have a fuller Review schema object to output it's better to
 * use that. This schema is optimized for specifically achieving star ratings
 * on search engine result pages while requiring as few inputs as possible.
 *
 * @param  {string} productName - Name of the product the rating applies to.
 * @param  {string|int} rating  - The rating value, out of 5.
 * @param  {string} author      - Name of the author of the rating.
 *
 * @return {Object|null}        - Schema data object, or null.
 */

var getMinimumStarRatingOnSERPsSchema = function getMinimumStarRatingOnSERPsSchema(productName, rating, author) {
  if (!productName || !rating || !author) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: productName,
    review: {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: author
      },
      reviewRating: getReviewRatingSchema(rating)
    }
  };
};

export default getMinimumStarRatingOnSERPsSchema;